export function calculateAnnualSavings(
  monthlyPrice: string,
  annualPrice: string,
) {
  if (!monthlyPrice || !annualPrice) return 0;

  const monthlyTotal = 12 * parseFloat(monthlyPrice);
  const savings =
    ((monthlyTotal - parseFloat(annualPrice)) / monthlyTotal) * 100;

  return Math.round(savings);
}
